<template>
  <Modal :open="open" size="medium" @close="closeModal">
    <div class="flex justify-between mb-4">
      <h1 class="text-gray-900 font-bold">Déclarer un échange de produit</h1>
    </div>

    <VeeForm v-slot="{ handleSubmit }" :validation-schema="schema" as="div">
      <form class="space-y-4" @submit="handleSubmit($event, handleExchangeProduct)" ref="ExchangeForm">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 my-4">
          <div>
            <label for="title" class="block text-sm text-gray-700">
              Nom du produit
              <span class="ml-1 text-red-600">*</span>
            </label>
            <div class="mt-2">
              <Field
                id="title"
                name="title"
                type="text"
                class="shadow-xs focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md"
                placeholder="Nom du produit"
                v-model="title"
              />
              <ErrorMessage name="title" class="mt-2 text-sm text-red-600" />
            </div>
          </div>
          <div>
            <label for="price" class="block text-sm text-gray-700">
              Prix du produit
              <span class="ml-1 text-red-600">*</span>
            </label>
            <div class="mt-2 relative">
              <Field
                id="price"
                name="price"
                type="text"
                class="pr-16 shadow-xs focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md"
                placeholder="249,99"
                v-model="priceFormatted"
              />
              <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                <span class="text-gray-500 sm:text-sm" id="price-currency">{{ currencyCode }}</span>
              </div>
              <ErrorMessage name="price" class="mt-2 text-sm text-red-600" />
            </div>
          </div>
          <div>
            <label for="referenceId" class="block text-sm text-gray-700">
              Numéro de série ou IMEI
              <span class="ml-1 text-red-600">*</span>
            </label>
            <div class="mt-2">
              <Field
                id="referenceId"
                name="referenceId"
                type="text"
                class="shadow-xs focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md"
                placeholder="35478405412998702"
                v-model="referenceId"
              />
              <ErrorMessage name="referenceId" class="mt-2 text-sm text-red-600" />
            </div>
          </div>
          <div>
            <label for="purchaseDate" class="block text-sm text-gray-700">
              Date d'achat
              <span class="ml-1 text-red-600">*</span>
            </label>
            <div class="mt-2 relative">
              <Field
                type="date"
                name="purchaseDate"
                id="purchaseDate"
                class="shadow-xs focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md"
                v-model="purchaseDate"
              />
              <ErrorMessage name="purchaseDate" class="mt-2 text-sm text-red-600" />
            </div>
          </div>
        </div>
        <div class="flex justify-center">
          <GenericButton class="mt-4" type="submit">Valider</GenericButton>
        </div>
      </form>
    </VeeForm>
  </Modal>
</template>

<script>
import { GenericButton, Modal } from "@estaly/ui";
import { ErrorMessage, Field, Form as VeeForm } from "vee-validate";
import * as yup from "yup";
import { mapActions } from "vuex";

export default {
  components: {
    GenericButton,
    Modal,
    ErrorMessage,
    Field,
    VeeForm,
  },

  props: {
    open: {
      type: Boolean,
      default: false,
    },
    plan: {
      type: Object,
      required: true,
    },
  },

  data() {
    const schema = yup.object({
      referenceId: yup.string().required("Le numéro de série est requis"),
      title: yup.string().required("Le nom du produit est requis"),
      price: yup
        .string()
        .required("Le prix du produit est requis.")
        .matches(/^\d+(\.\d{1,2})?$|^\d+(,\d{1,2})?$/, "Le format du prix est invalide."),
      purchaseDate: yup
        .date()
        .nullable()
        .transform((value, originalValue) => (originalValue === "" ? null : value))
        .max(new Date(new Date().setHours(23, 59, 59, 999)), "La date d'achat ne peut pas être dans le futur")
        .min(
          new Date(new Date().setDate(new Date().getDate() - 30)),
          "La date d'achat ne peut être supérieure à 30 jours",
        )
        .required("La date d'achat est requise")
        .typeError("La date d'achat est invalide"),
    });

    return {
      schema,
      referenceId: "",
      title: "",
      price: "",
      purchaseDate: "",
    };
  },

  computed: {
    priceFormatted: {
      get() {
        return this.price === undefined ? "" : this.price.toString().replace(".", ",");
      },
      set(value) {
        this.price = value.replace(",", ".");
      },
    },
  },

  methods: {
    ...mapActions("planSales", ["declareProductExchange"]),
    ...mapActions("notifications", ["notify"]),

    closeModal() {
      this.referenceId = "";
      this.title = "";
      this.price = "";
      this.purchaseDate = "";
      this.$emit("close");
    },

    async handleExchangeProduct() {
      const response = await this.declareProductExchange({
        friendlyId: this.plan.friendlyId,
        referenceId: this.referenceId,
        title: this.title,
        price: this.price,
        purchaseDate: this.purchaseDate,
        planSalePurchaseDate: this.plan.purchaseDate,
      });

      if (response?.success) {
        this.$emit("refreshPlanSale");
        this.closeModal();
      }
    },
  },
};
</script>
